import React, { useEffect, useState } from 'react';
import "aos/dist/aos.css";
import AOS from "aos";
import { Container, Row, Col, Card, ListGroup, Badge } from 'react-bootstrap';
import servicebanner from '../Assets/food/factory.jpg';
import '../Assets/WebsiteCss/services.css';
import { FaLightbulb, FaProjectDiagram, FaBoxOpen, FaCogs, FaFlask, FaShapes, FaCheckCircle, FaUsers, FaPlay, FaClipboardList, FaBroom, FaArrowRight } from 'react-icons/fa';

import { FaUserTie, FaHardHat, FaTools } from 'react-icons/fa';
import { GiChefToque  } from 'react-icons/gi';
import { MdPrecisionManufacturing } from 'react-icons/md';
import { BiGroup } from 'react-icons/bi';
import { Helmet } from "react-helmet";
import { MdFastfood } from "react-icons/md";
import { FaUserCog, FaStore  } from "react-icons/fa";
import { MdOutlineDoubleArrow } from "react-icons/md";

import {
  FaBoxes,
  FaUtensils,
  FaUsersCog,
  FaIndustry,
  FaThumbsUp,
  FaClipboardCheck,
} from 'react-icons/fa';

export default function Services() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const [activeModule, setActiveModule] = useState(0);


  const serviceFeatures = [
    {
      title: "Supervisor/Quality control staff",
      icon: <FaUserTie size={40} color="#23326a" />,
      description:
        "Experienced professionals specializing in namkeen production management, delivering seamless operations, disciplined workforce handling, and on-time production execution.",
    },
    {
      title: "Namkeen snacks workers",
      icon: <MdFastfood size={40} color="#23326a" />,
      description:
        "Our skilled Namkeen and snacks professionals bring expertise, precision, and creativity to every batch, ensuring high-quality, delicious treats for your business.",
    },
    {
      title: "Machine Operators",
      icon: <MdPrecisionManufacturing size={40} color="#23326a" />,
      description:
        "Trained workers who operate, monitor, and maintain automatic/semi-automatic namkeen packaging machines efficiently.",
    },
    {
      title: "Semi-Skilled Karigars",
      icon: <FaHardHat size={40} color="#23326a" />,
      description:
        "Support staff who assist in frying, seasoning, mixing, and moving products as per supervisor's instructions.",
    },
    {
      title: "Packing department staff",
      icon: <FaBoxOpen size={40} color="#23326a" />,
      description:
        "Our efficient packing department staff ensures every product is carefully handled, securely packed, and delivered on time, maintaining the highest standards of quality and safety.",
    },
    {
      title: "Bakery workers",
      icon: <GiChefToque  size={40} color="#23326a" />,
      description:
        "Our experienced bakery workers craft delicious baked goods with precision, creativity, and consistency, ensuring every product delights your customers.",
    },
    {
      title: "Full factory labor supply",
      icon: <FaUserCog size={40} color="#23326a" />,
      description:
        "We provide a reliable and skilled full factory labor force, equipped to handle production, assembly, and operational tasks efficientl, ensuring smooth and uninterrupted factory operations.",
    },
    {
      title: "Sweets (Mithai) workers",
      icon: <FaStore  size={40} color="#23326a" />,
      description:
        "Our experienced mithai workers craft traditional and modern sweets with skill and care, ensuring every treat is delicious and perfectly made.",
    }
  ];

  const modules = [
    {
      title: 'Training Programme for Production Team',
      description: `
        First of all, first module is like we provide a training programme to all your Production team 
        so that we can help the people to improve the taste in the namkeen & snacks. What is the need 
        of customers and also we can develop a new taste which is highly efficient. We also provide 
        a quality manager in order to provide the supervision for your ongoing processes.
      `
    },
    {
      title: 'New Business & Product Development',
      description: `
        Second, for a new business we can arrange a couple of weeks programme to new products development 
        and recipe or trained your team in a manner, so that you start your namkeen & snacks business in 
        healthy way. This learning must implement in every start-ups and it helping you out to enlarge 
        your own business.
      `
    },
    {
      title: 'Labour Contract & Production Support',
      description: `
        Third module what comes as the production module we provide the labour contract on the contract basis 
        so that they can go ahead for the daily production and there is a per kilogram rate for it that you how 
        to pay us for the costing production so we can also help you out in that manner and also if some of your 
        area man power supply have a gone for holidays and you are lacking some of the labour so we provide a 
        substitute for that purpose to carry on the work which helps in maintaining the consistency as well.
      `
    }
  ];

  const extraContent = `
    We are delighted to know that your company is engaged in a wide range of products and services. As your consultant, we ensure that working with snacks and namkeen production becomes a smooth, well-organized, and enjoyable experience. With Namkeen Contractor, you will find a reliable, friendly, and supportive working environment at every stage.
    Knowing many things before a new start of any work makes our way to reach success, that’s why our company works 
    with all our customers from the beginning of the work to the smooth running of the work in which includes the following tasks. We strongly believe that understanding every aspect before starting a new venture is the key to long-term success.
  `;

  const steps = [
    { icon: <FaLightbulb />, title: 'Idea' },
    { icon: <FaProjectDiagram />, title: 'Project Finalisation' },
    { icon: <FaBoxOpen />, title: 'Product Selection' },
    { icon: <FaCogs />, title: 'Machinery Selection' },
    { icon: <FaTools />, title: 'Installation' },
    { icon: <FaFlask />, title: 'Initial Production' },
    { icon: <FaShapes />, title: 'Variants Demo' },
    { icon: <FaCheckCircle />, title: 'Finalisation' },
    { icon: <FaUsers />, title: 'Team Setup' },
    { icon: <FaPlay />, title: 'Production Start' },
    { icon: <FaClipboardList />, title: 'Reporting' },
    { icon: <FaBroom />, title: 'Cleaning & Maintenance' },
  ];
  const borderColors = [
    '#ffc2c0ff', // red
    '#ace2ffff', // blue
    '#b5d3ffff', // teal
    '#fde4beff', // orange
    '#dcacfaff', // purple
    '#ffbbd3ff', // pink
  ];

  const services = [

    {
      icon: <FaCogs className=" text-danger" />,
      title: 'Processing machinery selection',
      description: 'We will suggest you the right machine in your budget to get production efficiently on regular basis.',
    },
    {
      icon: <FaTools className=" text-secondary" />,
      title: 'Machinery installation',
      description: 'To setup machinery line in order to maintain the work & supply line flow regularly.',
    },
    {
      icon: <FaFlask className=" text-info" />,
      title: 'Determination of initial production',
      description: 'As the machinery installation our experts will start pilot project for making the recipe.',
    },
    {
      icon: <FaLightbulb className=" text-warning" />,
      title: 'Idea-Project finalization Report',
      description: 'Understanding Idea & Concept of person. As per their demand & Market Requirments.',
    },
    {
      icon: <FaProjectDiagram className=" text-primary" />,
      title: 'Area Layout for Production and Storage.',
      description: 'After the project idea finalization. We will planning area layout for production to packaging and storage.',
    },
    {
      icon: <FaBoxes className=" text-success" />,
      title: 'Products Selecting Process',
      description: 'We will help you out to select the running products in their market & local areas.',
    },
    {
      icon: <FaIndustry className=" text-primary" />,
      title: 'Start final Production',
      description: 'After complete all the process, Our trained and experienced karigars and helpers will start the final production.',
    },
    {
      icon: <FaThumbsUp className=" text-info" />,
      title: 'Get Work Done',
      description: 'We will take feedback from you after the final production of recipe & team work.',
    },
    {
      icon: <FaClipboardCheck className=" text-dark" />,
      title: 'Reporting- Weekly Cleaning / Maintenance Programme',
      description: 'We will continuously reporting on weekly basis about cleaning & maintenances program.',
    },
    {
      icon: <FaUtensils className=" text-success" />,
      title: 'Demonstrate 3-4 various manner of each product.',
      description: 'After the initial production starts, we will demonstrate 3-4 various recipes & taste of each products.',
    },
    {
      icon: <FaCheckCircle className=" text-success" />,
      title: 'Product finalization work',
      description: 'We will help you out to select best recipe from which we demonstrated.',
    },
    {
      icon: <FaUsersCog className="text-warning" />,
      title: 'Determination of Production Team & Quality Experts.',
      description: 'After product finalization we select the best team of skilled persons to assign further processes.',
    }

  ];



  const serviceRows = [];
  for (let i = 0; i < services.length; i += 2) {
    serviceRows.push(services.slice(i, i + 2));
  }


  return (

    <div className="mainnav min-vh-100">


       <Helmet>
        {/* Page Title */}
        <title>Our Services | Karigar India Namkeen Labour Contractor</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Karigar India offers end-to-end skilled manpower solutions for Namkeen, Sweets, Snacks, Bakery, and packing departments. Experienced supervisors, Karigars, machine operators, and quality control staff ensure efficient production and top-quality output across India."
        />

        {/* Keywords */}
        <meta
          name="keywords"
          content="Karigar India, Namkeen Karigar, Sweets Karigar, Snacks Karigar, Bakery Karigar, Labour Contractor, Skilled Manpower, Production Team Training, Machine Operators, Packing Staff, Quality Control, Full Factory Labor Supply"
        />

        {/* Author */}
        <meta name="author" content="Karigar India" />

        {/* Robots */}
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Our Services | Karigar India Namkeen Labour Contractor" />
        <meta property="og:description" content="Providing skilled manpower and end-to-end labour contracting for namkeen, sweets, snacks, bakery, and packaging operations. From training production teams to full factory labor supply, we ensure efficiency and quality." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.karigarindia.in/services" />
        <meta property="og:image" content="https://www.karigarindia.in/logo.png" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Our Services | Karigar India Namkeen Labour Contractor" />
        <meta name="twitter:description" content="Skilled manpower for Namkeen, Sweets, Snacks, Bakery, and packing units. Karigar India ensures high-quality production with trained supervisors, machine operators, and packing staff." />
        <meta name="twitter:image" content="https://www.karigarindia.in/logo.png" />

        {/* Favicon */}
        <link rel="icon" href="/logo.png" />
      </Helmet>
      {/* Banner */}
      <div className="service-container">
        <img src={servicebanner} alt="" className="servicenamkken img-fluid" />
        <div className="service-overlay"></div>

        
      </div>

      <Container className="my-3">
        {/* Our Services */}
        <section className="" style={{ backgroundColor: "#f8f9fa" }}>
          <Container>
            <Row className="text-center" style={{ marginBottom: '5rem' }}>
              <Col>
                <h2
                  className="middletext mb-3" data-aos="zoom-in"
                >
                  Our Services
                </h2>
                <p className="lead text-muted">
                  End-to-end <b>labour contracting from manufacturing</b>  to final packing, powered by <b>automation and skilled hands</b>  for optimal efficiency.

                </p>
                <b>We Provide Services : </b>
              </Col>
            </Row>


            <Row className="justify-content-center mt-5  ">
              {serviceFeatures.map((service, idx) => (
                <Col md={4} xs={12} key={idx} style={{ marginBottom: "5rem" }}>
                  <div className="choose-card">

                    {/* ICON CIRCLE */}
                    <div className="icon-circle">
                      {service.icon}
                    </div>

                    {/* CARD CONTENT */}
                    <div className="card-content">
                      <h4>{service.title}</h4>
                      <p>{service.description}</p>
                    </div>

                  </div>
                  {/* <Card className="provideservice   h-100">
                        <Card.Body className="text-center">
                          {service.icon}
                          <h5 className="mt-3">{service.title}</h5>
                          <p className="text-muted">{service.description}</p>
                        </Card.Body>
                      </Card> */}
                </Col>
              ))}
            </Row>

          </Container>
        </section>

        {/* Stage of Process */}
        <section className="mb-5 mt-3">
          <Container>
            <h2 className="middletext mb-2 text-center" data-aos="zoom-in">
              Stages of Our Process
            </h2>

            <Card className="custom-card shadow p-2 border-0" style={{ backgroundColor: '#fdfdfd', borderRadius: '20px' }}>
              <Card.Body>
                <p className="text-muted text-center" style={{ fontSize: '1.1rem', lineHeight: '1.8', fontWeight: '500' }}>
                  We work in multiple stages, supporting you from the first idea to complete production.
                </p>

                {/* <div className="d-flex flex-wrap justify-content-center align-items-center gap-3 my-4 process-steps">
                  {steps.map((step, index) => (
                    <div key={index} className="d-flex align-items-center">
                      <div className="step-circle text-center">
                        <div className="step-icon">{step.icon}</div>
                        <small className="step-title">{step.title}</small>
                      </div>
                      {index !== steps.length - 1 && (
                        <MdOutlineDoubleArrow className="mx-2 text-arrow" />
                      )}
                    </div>
                  ))}
                </div> */}

                <div className="flow-container">
                  {steps.map((step, index) => (
                    <div
                      key={index}
                      className={`flow-step step-${index % 5}`}
                    >
                      <div className="flow-content">
                        <div className="flow-icon">{step.icon}</div>
                        <div>
                          <h6 className="flow-step-no">
                            Step {String(index + 1).padStart(2)}
                          </h6>
                          <p className="flow-title">{step.title}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>




                <p className="text-muted " style={{ fontSize: '1.1rem', lineHeight: '1.8', textAlign: 'justify', fontWeight: '460' }}>
                  We assist you in developing market-ready products and implementing efficient packaging solutions for snacks and namkeen. Our dedicated quality control managers and skilled workforce ensure smooth operations and consistent output. Whether managing large scale orders, maintaining product quality, or expanding your production team, we provide reliable support to help your business grow.
                </p>
              </Card.Body>
            </Card>
          </Container>
        </section>




        {/* Manufacturing Process */}


        {/* Working Module */}
        <section className="mb-3">
          <h2 className="middletext mb-4 text-center" data-aos="zoom-in">
            Working Module
          </h2>
          <Container>
            <Row className="justify-content-center">
              <Col md={10}>
                <Card className="p-4 shadow mt-2 mb-4">
                  <h4>Helping Businesses Grow with Expert Namkeen Knowledge & Seamless Support</h4>
                  <Card.Body>
                    <p style={{ textAlign: 'justify', whiteSpace: 'pre-line' }}>{extraContent.trim()}</p>
                  </Card.Body>
                </Card>

                <Card className=" shadow-lg">
                  <Row>
                    {/* Left side - Module titles */}
                    <Col md={4} className="border-end workingleft p-3">
                      <ListGroup variant="flush">
                        {modules.map((mod, index) => (
                          <ListGroup.Item
                            key={index}
                            action
                            onClick={() => setActiveModule(index)}
                            active={index === activeModule}
                            style={{
                              cursor: 'pointer',
                              fontWeight: 'bold',
                              borderRadius: '5px',
                              marginBottom: '5px'
                            }}
                          >
                            {mod.title}

                          </ListGroup.Item>
                        ))}
                      </ListGroup>

                    </Col>

                    {/* Right side - Description */}
                    <Col md={8} className='workingright p-3'>
                      <h4 className="mb-3 text-decoration-underline">{modules[activeModule].title}</h4>
                      <p style={{ textAlign: 'justify', whiteSpace: 'pre-line' }}>
                        {modules[activeModule].description.trim()}
                      </p>
                    </Col>
                  </Row>
                </Card>

                {/* Extra Section Below Modules */}

              </Col>
            </Row>
          </Container>
        </section>

        {/* Project Finalization & Production Setup */}
        <section className="mb-0 mt-5">
          <h2 className="middletext mb-3 " data-aos="zoom-in">Project Finalization & Production Setup</h2>
          <Row className="justify-content-center">
            <Col lg={8} className="text-center">
              <h3 className="fw-bold" style={{ color: "rgb(35, 50, 106)" }}>Our Services</h3>
              {/* <h6 className="text-muted">
                As we provide our work in different stages of all process in which we have things like helping with the full procedure from.
              </h6> */}
            </Col>
          </Row>

          <div style={{ background: '#fdfcfb' }}>
            <Container className="py-3">
              <Row className="mb-3">
                {services.map((service, idx) => (
                  <Col xs={12} sm={6} md={4} key={idx} className="mb-3">
                    <div
                      className="p-2 rounded shadow-sm h-100 servicepagecard"
                      style={{
                        backgroundColor: idx % 2 === 0 ? '#e4e3e3ff' : '#ffffffff',
                        borderLeft: `6px solid ${borderColors[idx % borderColors.length]}`,
                        borderTop: `6px solid ${borderColors[idx % borderColors.length]}`,
                      }}
                    >
                      <div className='text-center' style={{ fontSize: '25px' }}>
                        {service.icon}
                      </div>
                      <h5 className="fw-bold mb-2 prodsertitle text-center">
                        {service.title}
                      </h5>
                      <p className="text-muted mb-0 mx-2">
                        {service.description}
                      </p>
                    </div>
                  </Col>
                ))}

              </Row>
            </Container>

          </div>
        </section>


      </Container>
    </div >
  );
}




